import React from "react";

export class CasinoLink extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {     
        return <a className={this.props.className} onClick={(e) => { e.preventDefault(); parent.location = this.props.href}}>
            {this.props.children}
        </a>
    }
};
